export default {
  Settings: {
    SettingsDescription: 'Contact',
    Contact: {
      Title: 'Contact',
      Copy: 'Copy',
      Delete: 'Delete',
      CreateNew: {
        Action: 'Add new contact',
        ContactType: 'Contact type',
        ContactDetail: 'Contact detail',
        ContactTypeExample: {
          Email: 'Email',
          PhoneNumber: 'Phone number',
          EmergencyContact: 'Emergency contact',
        },
      },
    },
  },
  Correspondance: {
    Title: 'Correspondance',
    Filter: 'Filter',
    Header: {
      Description: 'Description',
      LastAnnouncement: 'Last announcement',
    },
    Type: {
      Comments: 'Comments',
      Announcements: 'Announcements',
      Logs: 'Logs',
    },
    Sort: {
      NewestFirst: 'Newest first',
      OldestFirst: 'Oldest first',
    },
    NewMessage: {
      Comments: 'Comments',
      Announcements: 'Announce',
      Cancel: 'Cancel',
      AddACommentOrAnnouncements: 'Add a comment or announcement',
    },
    Correspondance: {
      AnnouncedOn: 'Announced on',
      CommentedOn: 'Commented on',
      Logs: {
        CreatedOn: 'Created client on',
        EditName: 'Edited name on',
        EditDescription: 'Edited description on',
        EditStatus: 'Edited status on',
        EditPhoto: 'Edited photo on',
        EditContact: 'Added contact on',
        RemoveContact: 'Removed contact on',
      },
    },
    Messages: {
      LoadMore: 'Load more',
    },
    Logs: {
      EditContact: {
        Text: `#{type} added: #{detail}`,
      },
      RemoveContact: {
        Text: `#{type} removed: #{detail}`,
      },
      EditStatus: {
        Text: `Status changed from #{oldStatus} to #{newStatus}`,
      },
      EditName: {
        Text: `Client name changed from #{oldClientName} to #{newClientName}`,
      },
    },
  },
  Scheduling: {
    Title: 'Scheduling',
    AddNewSchedule: 'Add new schedule',
    ScheduleSetupWizard: 'Schedule setup wizard',
    ViewEvent: 'Viewing event',
    ViewRecurrence: 'Viewing recurrence',
    ViewLiveIn: 'Viewing live-in',
    DeleteEvent: 'Delete event',
    DeleteRecurrence: 'Delete recurrence',
    DeleteLiveIn: 'Delete live-in',
    ThisReccurenceIsDeleted: 'This recurrence has been deleted',
    ScheduleDetail: {
      Action: {
        Back: 'Back',
        Next: 'Next',
        Review: 'Review',
        Create: 'Create',
      },
      SelectEventType: {
        Title: 'Event type',
        FixedEventTitle: 'Fixed Event',
        FixedEventExplain: 'Schedule this as a one-time event for a specific date and time.',
        RecurringEventTitle: 'Recurring Event',
        RecurringEventExplain: 'Set this event to repeat on a regular basis (e.g., daily, weekly, or monthly).',
        LiveInEventTitle: 'Live In Event',
        LiveInEventExplain: 'Schedule this event for all day recurring events',
      },
      EventInfo: {
        Title: 'Event name',
        Description: 'Description',
        NoDescription: 'No description',
      },
      EventDate: {
        FixedEvent: {
          StartTime: 'Start time',
          EndTime: 'End time',
          Timezone: 'Timezone',
        },
        RecurrenceEvent: {
          StartDate: 'Start date',
          EndDate: 'End date',
          EndDateDisplay: 'End date or leave blank for infinity',
          Infinity: 'Infinity',
          Frequency: 'Frequency',
          FrequencyData: {
            DAILY: 'Daily',
            WEEKLY: 'WEEKLY',
            MONTHLY: 'MONTHLY',
            YEARLY: 'YEARLY',
          },
          Interval: 'Interval',
          StartTime: 'Start time',
          EndTime: 'End time',
          Timezone: 'Timezone',
          DayOfTheWeek: {
            SU: 'S',
            MO: 'M',
            TU: 'T',
            WE: 'W',
            TH: 'T',
            FR: 'F',
            SA: 'S',
          },
          ByWeekday: `By Weekday (e.g., day of the week)`,
          ByMonthDay: `By Month Day (e.g., 25)`,
          ByMonth: `By Month (e.g., 11)`,
        },
        LiveInEvent: {
          StartDate: 'Start date',
          EndDate: 'End date',
          EndDateDisplay: 'End date or leave blank for infinity',
          Infinity: 'Infinity',
          Frequency: 'Frequency',
          FrequencyData: {
            DAILY: 'Daily',
            WEEKLY: 'WEEKLY',
            MONTHLY: 'MONTHLY',
            YEARLY: 'YEARLY',
          },
          Interval: 'Interval',
          StartTime: 'Start time',
          EndTime: 'End time',
          Timezone: 'Timezone',
          DayOfTheWeek: {
            SU: 'S',
            MO: 'M',
            TU: 'T',
            WE: 'W',
            TH: 'T',
            FR: 'F',
            SA: 'S',
          },
          ByWeekday: `By Weekday (e.g., day of the week)`,
        },
      },
      Breaks: {
        Title: 'Breaks',
        BreakDuration: 'Break duration',
        BreakCount: 'Break count',
      },
      Caregiver: {
        CaregiverSearch: 'Caregiver',
      },
      Recurrence: {
        RotationRecurrenceMessage: '<b>This schedule is part of a recurrence.</b><br/>Recurring instances can only be deleted by editing the source.',
        EditRecurrence: 'Edit recurrence',
      },
      LiveIn: {
        RotationLiveInMessage: '<b>This schedule is part of a live-in.</b><br/>Live-in instances can only be deleted by editing the source.',
        EditLiveIn: 'Edit live-in',
      },
    },
    Summary: {
      SummaryTitle: 'Summary',
      Hours: 'Hours: #{hours} hrs',
      HourlyRate: 'Hourly rate: $#{cost}',
      Cost: 'Total cost: $#{cost}',
    },
    Timezone: {
      Timezones: 'Timezones',
    },
  },
  CaregiverConnections: {
    Title: 'Caregivers',
    AddCaregiver: {
      Title: 'Add caregiver to roster',
      CaregiverSearch: 'Caregiver',
      AddCaregiver: 'Add caregiver',
    },
    Caregiver: {
      CaregiverName: 'Caregiver name',
    },
  },
  Relationships: {
    Title: 'Relationships',
    AddRelationship: 'Add new relationship',
    EditRelationship: 'Edit relationship',
    Details: {
      Name: 'Name',
      ConnectionType: 'Connection relationship',
      Priority: 'Priority',
      Contacts: 'Contacts',
      ContactType: 'Contact type',
      ContactDetail: 'Contact detail',
      ContactTypeExample: {
        Email: 'Email',
        PhoneNumber: 'Phone number',
        EmergencyContact: 'Emergency contact',
      },
      AddNewContact: 'Add new contact',
      Description: 'Description',
      NoDescription: 'No description entered',
    },
    CreateRelationship: 'Create relationship',
    EditRelationship: 'Edit relationship',
    Authentication: {
      Title: 'Authentication',
      Active: 'Active',
      Activate: 'Activate User',
      Inactive: 'Inactive',
      Deactivate: 'Deactivate User',
      Authenticate: 'Authenticate User',
      NotAuthenticated: 'Not Authenticated',
      FirstName: 'First name',
      LastName: 'Last name',
      Cancel: 'Cancel',
      Submit: 'Submit',
      ResetPassword: 'Reset Password',
      Dialogs: {
        ConfirmDeactivateTitle: 'Confirm Deactivate',
        ConfirmDeactivateMessage: 'Are you sure you want to deactivate this user?',
        ConfirmActivateTitle: 'Confirm Activate',
        ConfirmActivateMessage: 'Are you sure you want to activate this user?',
        ConfirmResetPasswordTitle: 'Confirm Reset Password',
        ConfirmResetPasswordMessage: 'Are you sure you want to reset the password for this user?',
        ResetPasswordTitle: 'Reset Password',
        NewPassword: 'New Password',
      },
    },
    Notification: {
      Title: 'Notifications',
      Subscribe: 'Subscribe #{channelType}',
      Unsubscribe: 'Unsubscribe #{channelType}',
      NotSubscribed: 'Not Subscribed',
      Active: 'Active',
      Cancel: 'Cancel',
      NotSubscribed: 'Not Subscribed',
      Subscribed: 'Subscribed',
      Dialogs: {
        ConfirmUnsubscribeTitle: 'Confirm Unsubscribe',
        ConfirmUnsubscribeMessage: 'Are you sure you want to unsubscribe this user?',
        SmsHelperText: {
          InappropriateLength: 'Must be a valid CAN/US number (10 or 11 digits)',
          UnableToConvert: 'Unable to convert into valid CAN/US E.164 format (e.g. +14165551234). Please try again.',
        },
      },
      ChannelType: {
        Email: 'Email',
        Sms: 'SMS',
      },
    },
  },
  Payment: {
    Title: 'Payment',
    PaymentPlan: {
      Title: 'Payment details',
      HourlyRateTitle: 'Hourly Rate',
      NoHourlyRate: 'Hourly rate not set',
      HourlyCost: '$#{hourlyRate}',
      StripeIdTitle: 'Stripe ID',
      NoStripeId: 'Stripe ID does not exist',
    },
    Expense: {
      Amount: '$#{expenses}',
    },
    PaymentSlip: {
      Title: 'Payment slip',
    },
    WeekOf: `Week of #{date} #{status}`,
    HoursDisplay: `#{hours} hrs`,
    CostDisplay: `$#{cost}`,
    WaitingConfirmation: 'Waiting confirmation',
    Complete: 'Complete',
    WorkSummary: {
      Title: 'Work summary',
      TotalHours: 'Total Hours',
      TotalCost: 'Total Cost',
      ConfirmedHours: 'Confirmed Hours',
      ConfirmedCost: 'Confirmed Cost',
      ShiftsScheduled: 'Shifts Scheduled',
      HoursScheduled: 'Hours Scheduled',
      ShiftsWorked: 'Shifts Worked',
      HoursWorkedTitle: 'Hours Worked',
      PayRate: 'Pay Rate',
      TotalExpenses: 'Total Expenses',
      TotalPay: 'Total Pay',
      WeeklyProgress: {
        Title: 'Weekly Progress',
        Owed: 'Owed',
        ShiftsCompleted: '#{workedShifts} of #{totalShifts} shifts completed',
        CompletionRate: '#{percentage}% completion rate',
        ShiftsCompletedWithRate: '#{workedShifts} of #{totalShifts} shifts completed • #{percentage}% completion rate',
      },
      HoursWorked: {
        Title: 'Hours worked',
        ShiftHeader: `#{date} - #{title}`,
        ClockIn: 'Clock-in',
        ClockOut: 'Clock-out',
        HourlyRate: '$#{hourlyRate}/hr',
      },
    },
  },
  CareviewSettings: {
    Title: 'Careview',
    Types: {
      FiveStar: {
        Title: 'Five star',
        Question: 'Question',
      },
      FreeFormText: {
        Title: 'Free form question',
        Question: 'Question',
        RequirdTitle: 'Required field?',
        Enabled: 'Yes',
        Disabled: 'No',
        FieldIsRequired: 'Field is required to processed',
      },
      YesNo: {
        Title: 'Yes/No',
        Question: 'Question',
        Followup: 'Follow-up',
        FollowupEnabledYes: `Will trigger follow-up on 'Yes' response`,
        FollowupEnabledQuestionYes: `Trigger a follow-up on 'Yes' response`,
        FollowupEnabledNo: `Will trigger follow-up on 'No' response`,
        FollowupEnabledQuestionNo: `Trigger a follow-up on 'No' response`,
        Enabled: 'Enabled',
        Disabled: 'Disabled',
      },
      MultipleChoice: {
        Title: 'Multiple choice',
        Question: 'Question',
        Options: 'Options',
        OptionNumber: 'Option #{number}',
        FollowupEnable: `(Will trigger follow-up on response)`,
        Followup: `Follow up on this response`,
        AddNew: `Add new option`,
      },
      Actions: {
        Delete: 'Delete',
        Cancel: 'Cancel',
        Save: 'Save',
      },
    },
    NewQuestion: {
      Action: 'Add new question',
      Title: 'Add new question',
      SelectType: 'Select type',
    },
    ResetQuestions: {
      Action: 'Reset questions to default',
      AreYouSure: 'Are you sure you want to reset the questions to default?',
    },
  },
  Careplan: {
    Title: 'Careplan',
    Update: 'Update',
    GeneralInformation: {
      Title: 'General information',
      ClientName: 'Client name',
      NoClientname: 'No client name',
      Address: 'Address',
      NoAddress: 'No address',
      Information: 'Information',
      NoClientInformation: 'No client information',
      Notes: 'Notes',
      NoNotes: 'No notes',
    },
    MedicalHistory: {
      Title: 'Medical history',
      Medications: 'Medications',
      NoMedications: 'No medications',
      Conditions: 'Conditions',
      NoConditions: 'No conditions',
    },
    CareRoutine: {
      Title: 'Care routine',
      ClientPreferences: 'Client preferences',
      NoPreferences: 'No preferences',
      Tasks: 'Daily Tasks',
      NoTasks: 'No tasks',
    },
  },
  ChangeStatusDailog: {
    Title: 'Change status',
    Status: 'Status',
  },
  ChangeName: {
    Title: 'Change name',
    Name: 'Name',
  },
};
